export enum SseEvents {
  // source: pet.snoots.diagnostic
  DIAGNOSTIC_ARCHIVE_UPDATED = "pet.snoots.diagnostic:archive-updated",
  DIAGNOSTIC_BACKUP_CREATED = "pet.snoots.diagnostic:backup-created",
  DIAGNOSTIC_STUDY_CREATED = "pet.snoots.diagnostic:study-created",
  DIAGNOSTIC_STUDY_ARCHIVED = "pet.snoots.diagnostic:study-archived",
  DIAGNOSTIC_STUDY_RESTORED = "pet.snoots.diagnostic:study-restored",
  DIAGNOSTIC_STUDY_ASSIGNED = "pet.snoots.diagnostic:study-assigned",
  DIAGNOSTIC_STUDY_UPDATED = "pet.snoots.diagnostic:study-updated",
  DIAGNOSTIC_STUDY_REPORTED = "pet.snoots.diagnostic:study-reported",
  DIAGNOSTIC_STUDY_SHARED = "pet.snoots.diagnostic:study-shared",
  DIAGNOSTIC_STUDY_UNSHARED = "pet.snoots.diagnostic:study-unshared",
  DIAGNOSTIC_STUDY_DELETED = "pet.snoots.diagnostic:study-deleted",
  DIAGNOSTIC_STUDY_REJECTED = "pet.snoots.diagnostic:study-rejected",
  DIAGNOSTIC_STUDY_SHARING_FORCED = "pet.snoots.diagnostic:study-sharing-forced",
  DIAGNOSTIC_STUDY_ARCHIVING_REQUESTED = "pet.snoots.diagnostic:study-archiving-requested",
  DIAGNOSTIC_STUDY_IMPORTED = "pet.snoots.diagnostic:study-imported",
  DIAGNOSTIC_STUDY_DELIVERED = "pet.snoots.diagnostic:study-delivered",
  DIAGNOSTIC_REPORT_CREATED = "pet.snoots.diagnostic:report-created",
  DIAGNOSTIC_REPORT_REJECTED = "pet.snoots.diagnostic:report-rejected",
  DIAGNOSTIC_REQUEST_CREATED = "pet.snoots.diagnostic:request-created",
  DIAGNOSTIC_REQUEST_ACCEPTED = "pet.snoots.diagnostic:request-accepted",
  DIAGNOSTIC_REQUEST_UPDATED = "pet.snoots.diagnostic:request-updated",
  DIAGNOSTIC_REQUEST_DELETED = "pet.snoots.diagnostic:request-deleted",
  DIAGNOSTIC_REQUEST_REJECTED = "pet.snoots.diagnostic:request-rejected",
  DIAGNOSTIC_WORKLIST_CREATED = "pet.snoots.diagnostic:worklist-created",
  DIAGNOSTIC_WORKLIST_UPDATED = "pet.snoots.diagnostic:worklist-updated",
  DIAGNOSTIC_CONFIGURATION_UPDATED = "pet.snoots.diagnostic:configuration-updated",

  // source: pet.snoots.directory
  DIRECTORY_CUSTOMER_CREATED = "pet.snoots.directory:customer-created",
  DIRECTORY_CUSTOMER_DELETED = "pet.snoots.directory:customer-deleted",
  DIRECTORY_CUSTOMER_UPDATED = "pet.snoots.directory:customer-updated",
  DIRECTORY_PATIENT_CREATED = "pet.snoots.directory:patient-created",
  DIRECTORY_PATIENT_UPDATED = "pet.snoots.directory:patient-updated",
  DIRECTORY_PATIENT_MERGED = "pet.snoots.directory:patient-merged",
  DIRECTORY_PATIENT_RESURRECTED = "pet.snoots.directory:patient-resurrected",
  DIRECTORY_PATIENT_DECEASED = "pet.snoots.directory:patient-deceased",
  DIRECTORY_PATIENT_DELETED = "pet.snoots.directory:patient-deleted",
  DIRECTORY_PATIENT_WEIGHING = "pet.snoots.directory:patient-weighing-created",

  // source: pet.snoots.organization
  ORGANIZATION_ACCOUNT_CREATED = "pet.snoots.organization:account-created",
  ORGANIZATION_ACCOUNT_DELETED = "pet.snoots.organization:account-deleted",
  ORGANIZATION_ACCOUNT_UPDATED = "pet.snoots.organization:account-updated",

  // source: pet.snoots.calendar
  CALENDAR_APPOINTMENT_CREATED = "pet.snoots.calendar:appointment-created",
  CALENDAR_APPOINTMENT_UPDATED = "pet.snoots.calendar:appointment-updated",
  CALENDAR_APPOINTMENT_CANCELED = "pet.snoots.calendar:appointment-canceled",
  CALENDAR_APPOINTMENT_DELETED = "pet.snoots.calendar:appointment-deleted",
  CALENDAR_APPOINTMENT_RESCHEDULED = "pet.snoots.calendar:appointment-rescheduled",
  CALENDAR_APPOINTMENT_NOSHOWED = "pet.snoots.calendar:appointment-no-showed",

  // source: pet.snoots.healthcare
  HEALTHCARE_TICKET_CREATED = "pet.snoots.healthcare:ticket-created",
  HEALTHCARE_TICKET_UPDATED = "pet.snoots.healthcare:ticket-updated",
  HEALTHCARE_TICKET_DELETED = "pet.snoots.healthcare:ticket-deleted",
  HEALTHCARE_TICKET_CHECKED_IN = "pet.snoots.healthcare:ticket-checked-in",
  HEALTHCARE_TICKET_STARTED = "pet.snoots.healthcare:ticket-started",
  HEALTHCARE_TICKET_COMPLETED = "pet.snoots.healthcare:ticket-completed",
  HEALTHCARE_TICKET_CHECKED_OUT = "pet.snoots.healthcare:ticket-checked-out",
  HEALTHCARE_HEALTH_RECORD_TEMPLATE_CREATED = "pet.snoots.healthcare:health-record-template-created",
  HEALTHCARE_HEALTH_RECORD_TEMPLATE_CLONED = "pet.snoots.healthcare:health-record-template-cloned",
  HEALTHCARE_HEALTH_RECORD_TEMPLATE_UPDATED = "pet.snoots.healthcare:health-record-template-updated",
  HEALTHCARE_HEALTH_RECORD_TEMPLATE_DELETED = "pet.snoots.healthcare:health-record-template-deleted",
  HEALTHCARE_HEALTH_RECORD_DELETED = "pet.snoots.healthcare:health-record-deleted",
  HEALTHCARE_HEALTH_RECORD_CREATED = "pet.snoots.healthcare:health-record-created",
  HEALTHCARE_HEALTH_RECORD_UPDATED = "pet.snoots.healthcare:health-record-updated",
  HEALTHCARE_HEALTH_RECORD_COMPLETED = "pet.snoots.healthcare:health-record-completed",
  HEALTHCARE_HEALTH_RECORD_REOPENED = "pet.snoots.healthcare:health-record-reopened",
  HEALTHCARE_TASK_CREATED = "pet.snoots.healthcare:task-created",
  HEALTHCARE_TASK_UPDATED = "pet.snoots.healthcare:task-updated",
  HEALTHCARE_TASK_DELETED = "pet.snoots.healthcare:task-deleted",
  HEALTHCARE_TASK_COMPLETED = "pet.snoots.healthcare:task-completed",
  HEALTHCARE_RATE_TABLE_CREATED = "pet.snoots.healthcare:rate-table-created",
  HEALTHCARE_RATE_TABLE_UPDATED = "pet.snoots.healthcare:rate-table-updated",
  HEALTHCARE_RATE_TABLE_DELETED = "pet.snoots.healthcare:rate-table-deleted",
  HEALTHCARE_RATE_TABLE_ITEM_CREATED = "pet.snoots.healthcare:rate-table-item-created",
  HEALTHCARE_RATE_TABLE_ITEM_UPDATED = "pet.snoots.healthcare:rate-table-item-updated",
  HEALTHCARE_RATE_TABLE_ITEM_DELETED = "pet.snoots.healthcare:rate-table-item-deleted",
  HEALTHCARE_HOSPITALIZATION_CREATED = "pet.snoots.healthcare:hospitalization-created",
  HEALTHCARE_HOSPITALIZATION_UPDATED = "pet.snoots.healthcare:hospitalization-updated",
  HEALTHCARE_HOSPITALIZATION_DELETED = "pet.snoots.healthcare:hospitalization-deleted",
  HEALTHCARE_WORK_ORDER_CREATED = "pet.snoots.healthcare:work-order-created",
  HEALTHCARE_WORK_ORDER_UPDATED = "pet.snoots.healthcare:work-order-updated",
  HEALTHCARE_WORK_ORDER_RECONCILED = "pet.snoots.healthcare:work-order-reconciled",
  HEALTHCARE_WORK_ORDER_ITEM_ADDED = "pet.snoots.healthcare:work-order-item-added",
  HEALTHCARE_WORK_ORDER_ITEM_UPDATED = "pet.snoots.healthcare:work-order-item-updated",
  HEALTHCARE_WORK_ORDER_ITEM_DELETED = "pet.snoots.healthcare:work-order-item-deleted",
  HEALTHCARE_WORK_ORDER_DELETED = "pet.snoots.healthcare:work-order-deleted",
  HEALTHCARE_DRUG_CREATED = "pet.snoots.healthcare:drug-created",
  HEALTHCARE_DRUG_UPDATED = "pet.snoots.healthcare:drug-updated",
  HEALTHCARE_DRUG_DELETED = "pet.snoots.healthcare:drug-deleted",
  HEALTHCARE_PACKAGING_CREATED = "pet.snoots.healthcare:packaging-created",
  HEALTHCARE_PACKAGING_UPDATED = "pet.snoots.healthcare:packaging-updated",
  HEALTHCARE_PACKAGING_DELETED = "pet.snoots.healthcare:packaging-deleted",
  HEALTHCARE_PRODUCT_CREATED = "pet.snoots.healthcare:product-created",
  HEALTHCARE_PRODUCT_UPDATED = "pet.snoots.healthcare:product-updated",
  HEALTHCARE_MEDICAL_SERVICE_CREATED = "pet.snoots.healthcare:medical-service-created",
  HEALTHCARE_MEDICAL_SERVICE_UPDATED = "pet.snoots.healthcare:medical-service-updated",
  HEALTHCARE_MEDICAL_SERVICE_DELETED = "pet.snoots.healthcare:medical-service-deleted",
  HEALTHCARE_CONFIGURATION_HEALTHCARE_UPDATED = "pet.snoots.healthcare:configuration-healthcare-updated",
  HEALTHCARE_PRODUCT_DELETED = "pet.snoots.healthcare:product-deleted",
  HEALTHCARE_DOCUMENT_CREATED = "pet.snoots.healthcare:document-created",
  HEALTHCARE_DOCUMENT_UPDATED = "pet.snoots.healthcare:document-updated",
  HEALTHCARE_DOCUMENT_DELETED = "pet.snoots.healthcare:document-deleted",

  // source: pet.snoots.iam
  IAM_MEMBER_CREATED = "pet.snoots.iam:member-created",
  IAM_MEMBER_DELETED = "pet.snoots.iam:member-deleted",
  IAM_MEMBER_UPDATED = "pet.snoots.iam:member-updated",
  IAM_MEMBER_ENABLED = "pet.snoots.iam:member-enabled",
  IAM_MEMBER_DISABLED = "pet.snoots.iam:member-disabled",

  // source: pet.snoots.calendar
  CALENDAR_CONFIGURATION_UPDATED = "pet.snoots.calendar:calendar-configuration-updated",

  // source: pet.snoots.notification
  NOTIFICATION_MESSAGE_CREATED = "pet.snoots.notification:message-created",
  NOTIFICATION_MESSAGE_UPDATED = "pet.snoots.notification:message-updated",
  NOTIFICATION_MESSAGE_DELETED = "pet.snoots.notification:message-deleted",
  NOTIFICATION_MESSAGE_TEMPLATE_CREATED = "pet.snoots.notification:template-created",
  NOTIFICATION_MESSAGE_TEMPLATE_UPDATED = "pet.snoots.notification:template-updated",
  NOTIFICATION_MESSAGE_TEMPLATE_DELETED = "pet.snoots.notification:template-deleted",

  // source: pet.snoots.directory
  DIRECTORY_PHYSICIAN_CREATED = "pet.snoots.directory:physician-created",
  DIRECTORY_PHYSICIAN_UPDATED = "pet.snoots.directory:physician-updated",
  DIRECTORY_PHYSICIAN_DELETED = "pet.snoots.directory:physician-deleted",
  DIRECTORY_PHYSICIAN_DROP_PAGE_ENABLED = "pet.snoots.directory:physician-drop-page-enabled",
  DIRECTORY_PHYSICIAN_DROP_PAGE_DISABLED = "pet.snoots.directory:physician-drop-page-disabled",

  // source: pet.snoots.billing
  BILLING_CONFIGURATION_BILLING_UPDATED = "pet.snoots.billing:configuration-billing-updated",
  BILLING_CART_CREATED = "pet.snoots.billing:cart-created",
  BILLING_CART_ITEM_ADDED = "pet.snoots.billing:cart-item-added",
  BILLING_CART_ITEM_UPDATED = "pet.snoots.billing:cart-item-updated",
  BILLING_CART_ITEM_DELETED = "pet.snoots.billing:cart-item-deleted",
  BILLING_CART_UPDATED = "pet.snoots.billing:cart-updated",
  BILLING_INVOICE_CREATED = "pet.snoots.billing:invoice-created",
  BILLING_INVOICE_UPDATED = "pet.snoots.billing:invoice-updated",
  BILLING_INVOICE_EMITTED = "pet.snoots.billing:invoice-emitted",
  BILLING_INVOICE_DELETED = "pet.snoots.billing:invoice-deleted",
  BILLING_INVOICE_LOCKED = "pet.snoots.billing:invoice-locked",
  BILLING_INVOICE_UNLOCKED = "pet.snoots.billing:invoice-unlocked",
  BILLING_INVOICE_PAYMENT_ADDED = "pet.snoots.billing:invoice-payment-added",
  BILLING_INVOICE_PAYMENT_UPDATED = "pet.snoots.billing:invoice-payment-updated",
  BILLING_INVOICE_PAYMENT_DELETED = "pet.snoots.billing:invoice-payment-deleted",
  BILLING_INVOICE_ITEM_DELETED = "pet.snoots.billing:invoice-item-deleted",
  BILLING_FISCAL_PROFILE_CREATED = "pet.snoots.billing:fiscal-profile-created",
  BILLING_FISCAL_PROFILE_UPDATED = "pet.snoots.billing:fiscal-profile-updated",
  BILLING_FISCAL_PROFILE_DELETED = "pet.snoots.billing:fiscal-profile-deleted",
  BILLING_QUOTE_CREATED = "pet.snoots.billing:quote-created",
  BILLING_QUOTE_UPDATED = "pet.snoots.billing:quote-updated",
  BILLING_QUOTE_DELETED = "pet.snoots.billing:quote-deleted",
  BILLING_QUOTE_ACCEPTED = "pet.snoots.billing:quote-accepted",
  BILLING_QUOTE_REJECTED = "pet.snoots.billing:quote-rejected",
  BILLING_QUOTE_UNACCEPTED = "pet.snoots.billing:quote-unaccepted",
  BILLING_QUOTE_UNREJECTED = "pet.snoots.billing:quote-unrejected",
  BILLING_QUOTE_TEMPLATE_CREATED = "pet.snoots.billing:quote-template-created",
  BILLING_QUOTE_TEMPLATE_UPDATED = "pet.snoots.billing:quote-template-updated",
  BILLING_QUOTE_TEMPLATE_DELETED = "pet.snoots.billing:quote-template-deleted",
  BILLING_QUOTE_TEMPLATE_ITEM_ADDED = "pet.snoots.billing:quote-template-item-added",
  BILLING_QUOTE_TEMPLATE_ITEM_UPDATED = "pet.snoots.billing:quote-template-item-updated",
  BILLING_QUOTE_TEMPLATE_ITEM_DELETED = "pet.snoots.billing:quote-template-item-deleted",
  BILLING_BOOK_CREATED = "pet.snoots.billing:book-created",
  BILLING_BOOK_ITEM_ADDED = "pet.snoots.billing:book-item-added",
  BILLING_BOOK_ITEM_UPDATED = "pet.snoots.billing:book-item-updated",
  BILLING_BOOK_ITEM_DELETED = "pet.snoots.billing:book-item-deleted",
  BILLING_BOOK_ITEM_EXECUTORS_SET = "pet.snoots.billing:book-item-executors-set",
  BILLING_BOOK_ITEM_EXECUTION_DATE_SET = "pet.snoots.billing:book-item-execution-date-set",

  // source: pet.snoots.analytics
  ANALYTICS_SALE_CREATED = "pet.snoots.analytics:sale-created",

  // source: pet.snoots.iam
  IAM_USER_UPDATED = "pet.snoots.iam:user-updated",

  // source: pet.snoots.organization
  ORGANIZATION_TENANT_CREATED = "pet.snoots.organization:tenant-created",
  ORGANIZATION_TENANT_DELETED = "pet.snoots.organization:tenant-deleted",
  ORGANIZATION_TENANT_UPDATED = "pet.snoots.organization:tenant-updated",
  ORGANIZATION_DOMAIN_CREATED = "pet.snoots.organization:domain-created",
  ORGANIZATION_DOMAIN_UPDATED = "pet.snoots.organization:domain-updated",
  ORGANIZATION_DOMAIN_DELETED = "pet.snoots.organization:domain-deleted",

  // source: pet.snoots.healthcare
  HEALTHCARE_PRESCRIPTION_CREATED = "pet.snoots.healthcare:prescription-created",
  HEALTHCARE_PRESCRIPTION_UPDATED = "pet.snoots.healthcare:prescription-updated",
  HEALTHCARE_PRESCRIPTION_CANCELED = "pet.snoots.healthcare:prescription-canceled",
  HEALTHCARE_PRESCRIPTION_DELETED = "pet.snoots.healthcare:prescription-deleted",
  HEALTHCARE_PRESCRIPTION_EMITTED = "pet.snoots.healthcare:prescription-emitted",
  HEALTHCARE_PRESCRIPTION_DRUG_ADDED = "pet.snoots.healthcare:prescription-drug-added",
  HEALTHCARE_PRESCRIPTION_DRUG_UPDATED = "pet.snoots.healthcare:prescription-drug-updated",
  HEALTHCARE_PRESCRIPTION_DRUG_DELETED = "pet.snoots.healthcare:prescription-drug-deleted",

  // source: pet.snoots.diagnostic
  DIAGNOSTIC_ATTACHMENT_CREATED = "pet.snoots.diagnostic:attachment-created",
  DIAGNOSTIC_ATTACHMENT_UPDATED = "pet.snoots.diagnostic:attachment-updated",
  DIAGNOSTIC_ATTACHMENT_UPLOADED = "pet.snoots.diagnostic:attachment-uploaded",
  DIAGNOSTIC_ATTACHMENT_DELETED = "pet.snoots.diagnostic:attachment-deleted",
  // source: pet.snoots.directory
  DIRECTORY_ATTACHMENT_CREATED = "pet.snoots.directory:attachment-created",
  DIRECTORY_ATTACHMENT_UPDATED = "pet.snoots.directory:attachment-updated",
  DIRECTORY_ATTACHMENT_UPLOADED = "pet.snoots.directory:attachment-uploaded",
  DIRECTORY_ATTACHMENT_DELETED = "pet.snoots.directory:attachment-deleted",
  // source: pet.snoots.healthcare
  HEALTHCARE_ATTACHMENT_CREATED = "pet.snoots.healthcare:attachment-created",
  HEALTHCARE_ATTACHMENT_UPDATED = "pet.snoots.healthcare:attachment-updated",
  HEALTHCARE_ATTACHMENT_UPLOADED = "pet.snoots.healthcare:attachment-uploaded",
  HEALTHCARE_ATTACHMENT_DELETED = "pet.snoots.healthcare:attachment-deleted",
  // source: pet.snoots.calendar
  CALENDAR_ATTACHMENT_CREATED = "pet.snoots.calendar:attachment-created",
  CALENDAR_ATTACHMENT_UPDATED = "pet.snoots.calendar:attachment-updated",
  CALENDAR_ATTACHMENT_UPLOADED = "pet.snoots.calendar:attachment-uploaded",
  CALENDAR_ATTACHMENT_DELETED = "pet.snoots.calendar:attachment-deleted",
  // source: pet.snoots.billing
  BILLING_ATTACHMENT_CREATED = "pet.snoots.billing:attachment-created",
  BILLING_ATTACHMENT_UPDATED = "pet.snoots.billing:attachment-updated",
  BILLING_ATTACHMENT_UPLOADED = "pet.snoots.billing:attachment-uploaded",
  BILLING_ATTACHMENT_SIGNED = "pet.snoots.billing:attachment-signed",
  BILLING_ATTACHMENT_DELETED = "pet.snoots.billing:attachment-deleted",
  // source: pet.snoots.healthcare
  HEALTHCARE_WORK_ORDER_EXAM_PARAMETER_UPDATED = "pet.snoots.healthcare:work-order-exam-parameter-updated",
  // source: pet.snoots.tag
  TAG_TAG_CREATED = "pet.snoots.tag:tag-created",
  TAG_TAG_UPDATED = "pet.snoots.tag:tag-updated",
  TAG_TAG_DELETED = "pet.snoots.tag:tag-deleted",
  // source: pet.snoots.billing
  BILLING_SENDING_CREATED = "pet.snoots.billing:sending-created",
  BILLING_SENDING_UPDATED = "pet.snoots.billing:sending-updated",
  BILLING_SENDING_SENT = "pet.snoots.billing:sending-sent",
  BILLING_SENDING_DISCARDED = "pet.snoots.billing:sending-discarded",
  BILLING_SENDING_REJECTED = "pet.snoots.billing:sending-rejected",
  BILLING_SENDING_OUTCOME_DETAIL_UPLOADED = "pet.snoots.billing:sending-outcome-detail-uploaded",
  BILLING_SENDING_RECEIPT_UPLOADED = "pet.snoots.billing:sending-receipt-uploaded",
  // source: pet.snoots.calendar
  CALENDAR_APPOINTMENT_TEMPLATE_CREATED = "pet.snoots.calendar:appointment-template-created",
  CALENDAR_APPOINTMENT_TEMPLATE_UPDATED = "pet.snoots.calendar:appointment-template-updated",
  CALENDAR_APPOINTMENT_TEMPLATE_DELETED = "pet.snoots.calendar:appointment-template-deleted",
  // source: pet.snoots.billing
  BILLING_PAYMENT_METHOD_CREATED = "pet.snoots.billing:payment-method-created",
  BILLING_PAYMENT_METHOD_UPDATED = "pet.snoots.billing:payment-method-updated",
  BILLING_PAYMENT_METHOD_DELETED = "pet.snoots.billing:payment-method-deleted",
  BILLING_PAYMENT_METHOD_DISABLED = "pet.snoots.billing:payment-method-disabled",
  // source: pet.snoots.healthcare
  HEALTHCARE_EXPORT_CREATED = "pet.snoots.healthcare:export-created",
  HEALTHCARE_EXPORT_COMPLETED = "pet.snoots.healthcare:export-completed",
  HEALTHCARE_EXPORT_REJECTED = "pet.snoots.healthcare:export-rejected",
  HEALTHCARE_IMPORT_CREATED = "pet.snoots.healthcare:import-created",
  HEALTHCARE_IMPORT_COMPLETED = "pet.snoots.healthcare:import-completed",
  HEALTHCARE_IMPORT_REJECTED = "pet.snoots.healthcare:import-rejected",
  // source: pet.snoots.billing
  BILLING_BANK_ACCOUNTS_CREATED = "pet.snoots.billing:bank-accounts-created",
  BILLING_BANK_ACCOUNTS_UPDATED = "pet.snoots.billing:bank-accounts-updated",
  BILLING_BANK_ACCOUNTS_DELETED = "pet.snoots.billing:bank-accounts-deleted",
  // source: pet.snoots.notification
  NOTIFICATION_REMINDER_CREATED = "pet.snoots.notification:reminder-created",
  NOTIFICATION_REMINDER_DELETED = "pet.snoots.notification:reminder-deleted",
  NOTIFICATION_REMINDER_UPDATED = "pet.snoots.notification:reminder-updated",
  NOTIFICATION_REMINDER_SENT = "pet.snoots.notification:reminder-sent",
  // source: pet.snoots.billing
  BILLING_PASSIVE_INVOICE_CREATED = "pet.snoots.billing:passive-invoice-created",
  BILLING_PASSIVE_INVOICE_PAYMENT_ADDED = "pet.snoots.billing:passive-invoice-payment-added",
  BILLING_PASSIVE_INVOICE_PAYMENT_UPDATED = "pet.snoots.billing:passive-invoice-payment-updated",
  BILLING_PASSIVE_INVOICE_PAYMENT_DELETED = "pet.snoots.billing:passive-invoice-payment-deleted",
  // source: pet.snoots.healthcare
  HEALTHCARE_RECOVERY_CREATED = "pet.snoots.healthcare:recovery-created",
  HEALTHCARE_RECOVERY_DELETED = "pet.snoots.healthcare:recovery-deleted",
  HEALTHCARE_RECOVERY_UPDATED = "pet.snoots.healthcare:recovery-updated",
  HEALTHCARE_RECOVERY_COMPLETED = "pet.snoots.healthcare:recovery-completed",
  // source: pet.snoots.warehouse
  WAREHOUSE_GOOD_CREATED = "pet.snoots.warehouse:good-created",
  WAREHOUSE_GOOD_UPDATED = "pet.snoots.warehouse:good-updated",
  WAREHOUSE_GOOD_LOADED = "pet.snoots.warehouse:good-loaded",
  WAREHOUSE_GOOD_UNLOADED = "pet.snoots.warehouse:good-unloaded",
  WAREHOUSE_GOOD_DELETED = "pet.snoots.warehouse:good-deleted",
  // source: pet.snoots.healthcare
  HEALTHCARE_VACCINE_CREATED = "pet.snoots.healthcare:vaccine-created",
  HEALTHCARE_VACCINE_DELETED = "pet.snoots.healthcare:vaccine-deleted",
  HEALTHCARE_VACCINE_UPDATED = "pet.snoots.healthcare:vaccine-updated",
  // source: pet.snoots.healthcare
  HEALTHCARE_LETTERHEAD_CREATED = "pet.snoots.healthcare:letterhead-created",
  HEALTHCARE_LETTERHEAD_UPDATED = "pet.snoots.healthcare:letterhead-updated",
  HEALTHCARE_LETTERHEAD_DELETED = "pet.snoots.healthcare:letterhead-deleted",
  // source: pet.snoots.diagnostic
  DIAGNOSTIC_LETTERHEAD_CREATED = "pet.snoots.diagnostic:letterhead-created",
  DIAGNOSTIC_LETTERHEAD_UPDATED = "pet.snoots.diagnostic:letterhead-updated",
  DIAGNOSTIC_LETTERHEAD_DELETED = "pet.snoots.diagnostic:letterhead-deleted",
  // source: pet.snoots.healthcare
  HEALTHCARE_ROOM_CREATED = "pet.snoots.healthcare:room-created",
  HEALTHCARE_ROOM_UPDATED = "pet.snoots.healthcare:room-updated",
  HEALTHCARE_ROOM_DELETED = "pet.snoots.healthcare:room-deleted",
  HEALTHCARE_ROLE_CREATED = "pet.snoots.healthcare:role-created",
  HEALTHCARE_ROLE_DELETED = "pet.snoots.healthcare:role-deleted",
  HEALTHCARE_ROLE_UPDATED = "pet.snoots.healthcare:role-updated",
  // source: pet.snoots.calendar
  CALENDAR_SHIFT_ADDED = "pet.snoots.calendar:shift-added",
  CALENDAR_SHIFT_UPDATED = "pet.snoots.calendar:shift-updated",
  CALENDAR_SHIFT_DELETED = "pet.snoots.calendar:shift-deleted",
  // source: pet.snoots.billing
  BILLING_FISCAL_PROFILE_SECTIONAL_ADDED = "pet.snoots.billing:fiscal-profile-sectional-added",
  BILLING_FISCAL_PROFILE_SECTIONAL_UPDATED = "pet.snoots.billing:fiscal-profile-sectional-updated",
  BILLING_FISCAL_PROFILE_SECTIONAL_DELETED = "pet.snoots.billing:fiscal-profile-sectional-deleted",
  // source: pet.snoots.warehouse
  WAREHOUSE_STORAGE_CREATED = "pet.snoots.warehouse:storage-created",
  WAREHOUSE_STORAGE_DELETED = "pet.snoots.warehouse:storage-deleted",
  WAREHOUSE_STORAGE_UPDATED = "pet.snoots.warehouse:storage-updated",
  // source: pet.snoots.directory
  DIRECTORY_SUPPLIER_CREATED = "pet.snoots.directory:supplier-created",
  DIRECTORY_SUPPLIER_DELETED = "pet.snoots.directory:supplier-deleted",
  DIRECTORY_SUPPLIER_UPDATED = "pet.snoots.directory:supplier-updated",
  // source: pet.snoots.warehouse
  WAREHOUSE_MOVEMENT_CREATED = "pet.snoots.warehouse:movement-created",
  WAREHOUSE_MOVEMENT_DELETED = "pet.snoots.warehouse:movement-deleted",
  WAREHOUSE_MOVEMENT_UPDATED = "pet.snoots.warehouse:movement-updated",
  WAREHOUSE_BUSINESS_UNIT_CREATED = "pet.snoots.warehouse:business-unit-created",
  WAREHOUSE_BUSINESS_UNIT_DELETED = "pet.snoots.warehouse:business-unit-deleted",
  WAREHOUSE_BUSINESS_UNIT_UPDATED = "pet.snoots.warehouse:business-unit-updated",
  // source: pet.snoots.healthcare
  HEALTHCARE_SURVEY_CREATED = "pet.snoots.healthcare:survey-created",
  HEALTHCARE_SURVEY_COMPLETED = "pet.snoots.healthcare:survey-completed",
  HEALTHCARE_SURVEY_SENT = "pet.snoots.healthcare:survey-sent",
  // source: pet.snoots.notification
  NOTIFICATION_ALARM_CREATED = "pet.snoots.notification:alarm-created",
  // source: pet.snoots.integrator
  INTEGRATOR_INSTALLATION_CREATED = "pet.snoots.integrator:installation-created",
  INTEGRATOR_INSTALLATION_DELETED = "pet.snoots.integrator:installation-deleted",
  INTEGRATOR_INSTALLATION_UPDATED = "pet.snoots.integrator:installation-updated",
  INTEGRATOR_INSTALLATION_DISABLED = "pet.snoots.integrator:installation-disabled",
  INTEGRATOR_INSTALLATION_ENABLED = "pet.snoots.integrator:installation-enabled",
  INTEGRATOR_CONNECTION_CREATED = "pet.snoots.integrator:connection-created",
  INTEGRATOR_CONNECTION_DELETED = "pet.snoots.integrator:connection-deleted",
  INTEGRATOR_CONNECTION_UPDATED = "pet.snoots.integrator:connection-updated",
  INTEGRATOR_CONNECTION_SHARED = "pet.snoots.integrator:connection-shared",
  INTEGRATOR_CONNECTION_UNSHARED = "pet.snoots.integrator:connection-unshared",
  // source: pet.snoots.notification
  NOTIFICATION_CAMPAIGN_CREATED = "pet.snoots.notification:campaign-created",
  NOTIFICATION_CAMPAIGN_UPDATED = "pet.snoots.notification:campaign-updated",
  NOTIFICATION_CAMPAIGN_DELETED = "pet.snoots.notification:campaign-deleted",
  NOTIFICATION_CAMPAIGN_ENABLED = "pet.snoots.notification:campaign-enabled",
  NOTIFICATION_CAMPAIGN_DISABLED = "pet.snoots.notification:campaign-disabled",
  NOTIFICATION_CAMPAIGN_SENT = "pet.snoots.notification:campaign-sent",
  NOTIFICATION_SEGMENTATION_CREATED = "pet.snoots.notification:segmentation-created",
  NOTIFICATION_SEGMENTATION_UPDATED = "pet.snoots.notification:segmentation-updated",
  NOTIFICATION_SEGMENTATION_DELETED = "pet.snoots.notification:segmentation-deleted",
  // source: pet.snoots.store
  STORE_SERVICE_CREATED = "pet.snoots.store:store-service-created",
  STORE_SERVICE_UPDATED = "pet.snoots.store:store-service-updated",
  STORE_SERVICE_DELETED = "pet.snoots.store:store-service-deleted",
  STORE_ORDER_CREATED = "pet.snoots.store:order-created",
  STORE_ORDER_UPDATED = "pet.snoots.store:order-updated",
  STORE_ORDER_DELETED = "pet.snoots.store:order-deleted",
  // source: pet.snoots.diagnostic
  DIAGNOSTIC_DRAFT_DOCUMENT_CREATED = "pet.snoots.diagnostic:draft-document-created",
  DIAGNOSTIC_DRAFT_DOCUMENT_UPDATED = "pet.snoots.diagnostic:draft-document-updated",
  DIAGNOSTIC_DRAFT_DOCUMENT_DELETED = "pet.snoots.diagnostic:draft-document-deleted"
}
